



















































































































































































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwTitlePane } from '@libs-uuif/shared/sw-title-pane';
import { required, email, maxLength, helpers } from 'vuelidate/lib/validators';
import { AddressInfo } from './types';
import { MswApiService } from '@/shared/msw-api-service';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import RegexValidators from '@/shared/regex-validators';
import  EncryptAesService  from '../encryptAesService';
import { InfoState } from '../../core';
import { Country, State } from '../../shared/country-state-component/types';
import { StateList } from '../statesList';
const cssPrefix = 'changeBillingAddress';
const addressCheck = helpers.regex('addressCheck', new RegExp(RegexValidators.address));
const postalCode = helpers.regex('postalCode', new RegExp(RegexValidators.postalCode));
const phone = helpers.regex('phone', new RegExp(RegexValidators.phoneNo));
@Component({
  components:{
    ...UUIFComponents,
    SwForm,
    SwFormRow,
    SwTextfield,
    SwTitlePane,
    SwActionBar,
    SwActionBarItem,
    SwCheckbox,
  },
  validations: {
    addressInfo: {
      fullName: { required, maxLength: maxLength(50) },
      address1: { required, addressCheck, maxLength: maxLength(50) },
      address2: { required, maxLength: maxLength(50)  },
      city: { required, addressCheck, maxLength: maxLength(50) },
      zipcode: { required, postalCode, maxLength: maxLength(50) },
      phone: { required, phone },
      emailAddress: { required, email },
    },
  },
})
export default class ChangeBillingAddress extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: String })
  addressID: string;
  @Prop({ type: String })
  autorenewalID: string;
  addressInfo: AddressInfo = {
    fullName: '',
    address1: '',
    address2: '',
    city: '',
    zipcode: '',
    phone: '',
    province: '',
    country: '',
    state: '',
    vatNumber:'',
    emailAddress: '',
    creditCardNo:'',
    cvv:'',
  };
  months: SelectOption[] = [{ value: '01', label: 'January', id:'01'  },
                            { value: '02', label: 'February', id:'02' },
                            { value: '03', label: 'March', id:'03' },
                            { value: '04', label: 'April', id:'04' },
                            { value: '05', label: 'May', id:'05' },
                            { value: '06', label: 'June', id:'06' },
                            { value: '07', label: 'July', id:'07' },
                            { value: '08', label: 'August', id:'08' },
                            { value: '09', label: 'September', id:'09' },
                            { value: '10', label: 'October', id:'10' },
                            { value: '11', label: 'November', id:'11' },
                            { value: '12', label: 'December', id:'12' }];
  years: SelectOption[] = [];
  selectedMonth: SelectOption;
  selectedYear: SelectOption;
  isCCDataEditable:boolean = false;

  initCCNo: string = '';
  initSecurityCode: string = '';
  initCCMonth: SelectOption = { value: '', label: '', id:'' };
  initCCYear: SelectOption = { value: '', label: '', id:'' };
  initCardType: string = '';

  isVatRequired: boolean = false;
  imgCardType: string = '';
  selectedCardType: string = 'none';
  isCardTypeErr: boolean = false;
  isReadOnlyAccess: boolean = false;
  shouldPostCCInfo: boolean = false;

  visaPath: string = 'https://www.mysonicwall.com/muir/assets/images/visa.png';
  mastercaerPath: string = 'https://www.mysonicwall.com/muir/assets/images/mastercard.png';
  discoverPath: string = 'https://www.mysonicwall.com/muir/assets/images/discover.png';
  amexPath: string = 'https://www.mysonicwall.com/muir/assets/images/amex.png';
  echeckPath: string = 'https://www.mysonicwall.com/muir/assets/images/echeck.png';

  ccNoInputTouched: boolean = false;
  ccCVVInputTouched: boolean = false;
  submitClicked: boolean = false;
  isSubUser: boolean = false;

  countries: any = [];
  states: any = [];
  showCAorUS: boolean = false;

  get countriesOptions() : SelectOption[]  {
    const tempArr: SelectOption[] = [];
    this.countries.map((country: Country) => {
      tempArr.push({
        id: country.countryCode ? country.countryCode : '',
        value: country.countryCode ? country.countryCode : '',
        label: country.countryName ? country.countryName : '',
      });
    });
    return tempArr;
  }

  get statesOptions() : SelectOption[] {
    const tempArr: SelectOption[] = [];
    this.states = this.addressInfo.country === 'US' ? [...StateList.US] : this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
    this.states && this.states.map((state: State) => {
      tempArr.push({
        id: state.stateCode ? state.stateCode : '',
        value: state.stateCode ? state.stateCode : '',
        label: state.stateName ? `${this.$t(state.stateName)}` : '',
      });
    });
    return tempArr;
  }

  onCountryChange() {
    this.addressInfo.vatNumber = '';
    this.addressInfo.gstNumber = '';
    this.isVatRequired = this.countries.filter((cotry: Country) => { return cotry.countryCode === this.addressInfo.country; })[0].isVatRequired;
    // this.showGst = this.countries.filter((country: Country) => { return country.countryCode === this.addressInfo.country; })[0].isGstRequired;
    if (this.addressInfo.country === 'US' || this.addressInfo.country === 'CA') {
      this.showCAorUS = true;
      this.states = this.addressInfo.country === 'US' ? [...StateList.US] :
      this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
      const stateCode = this.states.filter((state : State) => state.stateCode === this.addressInfo.state)[0]?.stateCode || '';
      this.addressInfo.state = stateCode ? stateCode : this.states[0].stateCode;
    } else {
      this.showCAorUS = false;
      this.addressInfo.province = this.addressInfo.province ? this.addressInfo.province : '';
    }
  }

  getCountriesOption() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getCountriesFromServer', 'NO')
    .then((resp) => {
      if (resp?.operationStatus === 'OK') {
        this.$store.commit('stopLoading');
        this.countries = resp?.content?.lstCountries ||  [];
      }
    });
  }

  created() {
    this.getCountriesOption();
    this.getAddressInfo();
    const yr = (new Date()).getFullYear();
    for (let i = 0; i < 11; i += 1) {
      this.years.push({ id: String(yr + i), label: String(yr + i), value: String(yr + i) });
    }
    this.selectedMonth = this.months[0];
    this.selectedYear = this.years[0];
  }
  mounted() {
    this.isSubUser = this.$router.currentRoute.query.snbuser ? true : false;
  }
  getAddressInfo() {
    this.$store.commit('startLoading');
    MswApiService.editQuote.getBillingAddress(this.addressID)
      .then((resp: any) => {
        if (resp.msgCode	=== 'MSWAPP:SUCCESS') {
          this.addressInfo = resp.content ? resp.content : {};
          this.showCAorUS = this.addressInfo.country === 'US' || this.addressInfo.country === 'CA';
          this.isVatRequired = this.countries.filter((cotry: Country) => { return cotry.countryCode === this.addressInfo.country; })[0].isVatRequired;
          // this.showGst = this.countries.filter((country: Country) => { return country.countryCode === this.addressInfo.country; })[0].isGstRequired;
          this.isReadOnlyAccess =  resp.content.isReadOnlyAccess ? resp.content.isReadOnlyAccess : false;
          if (this.addressInfo.creditCardNo && this.addressInfo.creditCardNo !== '') {
            this.shouldPostCCInfo = true;
          }
          this.selectedCardType = this.addressInfo.creditCardType ? this.addressInfo.creditCardType : '';
          this.initCardType = this.addressInfo.creditCardType ? this.addressInfo.creditCardType : '';
          this.initCCNo = this.addressInfo.creditCardNo ? this.addressInfo.creditCardNo : '';
          this.initSecurityCode = this.addressInfo.cvv ? this.addressInfo.cvv : '';
          this.initCCMonth = this.months.filter(m => m.value === this.addressInfo.ccMonth)[0];
          this.initCCYear = this.years.filter(y => y.value === this.addressInfo.ccYear)[0] ?
            this.years.filter(y => y.value === this.addressInfo.ccYear)[0] :
            this.years[0];
          if (this.selectedCardType) this.setImgCardType(this.selectedCardType);
          this.$store.commit('stopLoading');
        } else {
          this.$store.commit('stopLoading');
        }
      })
      .catch((errRes: any) => {
        console.warn(errRes);
        this.$store.commit('stopLoading');
      });
  }
  checkInputValidation(): boolean {
    this.$v?.addressInfo?.$touch();
    if (!this.$v!.addressInfo!.fullName!.$invalid &&
       !this.$v!.addressInfo!.address1!.$invalid &&
       !this.$v!.addressInfo!.address2!.$invalid &&
       !this.$v!.addressInfo!.city!.$invalid &&
       !this.$v!.addressInfo!.zipcode!.$invalid &&
       !this.$v!.addressInfo!.phone!.$invalid &&
       !this.$v!.addressInfo!.emailAddress!.$invalid &&
       ((!this.showCAorUS && this.addressInfo?.province !== '') || this.showCAorUS) &&
       ((this.isVatRequired && this.addressInfo?.vatNumber !== '') || !this.isVatRequired) &&
       (!this.isCardTypeErr &&
       (this.addressInfo.creditCardNo != null && this.addressInfo.creditCardNo.length > 11) &&
       this.selectedMonth.value &&
       this.selectedYear.value &&
       (this.addressInfo.cvv != null && this.addressInfo.cvv.length > 2))) {
      return true;
    }
    return false;
  }
  onEditAddress() {
    this.submitClicked = true;
    if (this.checkInputValidation()) {
      const address = {
        fullName: this.addressInfo.fullName ? this.addressInfo.fullName.trim() : '',
        address1: this.addressInfo.address1 ? this.addressInfo.address1.trim() : '',
        address2: this.addressInfo.address2 ? this.addressInfo.address2.trim() : '',
        city: this.addressInfo.city ? this.addressInfo.city.trim() : '',
        state: this.showCAorUS ? this.addressInfo.state : '',
        province: this.addressInfo.province ? this.addressInfo.province.trim() : '',
        country: this.addressInfo.country ? this.addressInfo.country.trim() : '',
        zipcode: this.addressInfo.zipcode ? this.addressInfo.zipcode.trim() : '',
        phone: this.addressInfo.phone ? this.addressInfo.phone.trim() : '',
        emailAddress: this.addressInfo.emailAddress ? this.addressInfo.emailAddress.trim() : '',
        vatNumber: this.isVatRequired ? this.addressInfo?.vatNumber ? this.addressInfo?.vatNumber.trim() : '' : '',
        // tslint:disable-next-line
        enccardetails: (this.isCCDataEditable) ? EncryptAesService.encryptText(`${this.selectedCardType}^${this.addressInfo.creditCardNo}^${this.selectedMonth.value}/${this.selectedYear.value}^${this.addressInfo.cvv}`).toString() : '',
        customerAddressId: this.addressID ? this.addressID : '',
        autoRenewalId: '',
      };
      if (this.autorenewalID &&
        this.autorenewalID !== null &&
        this.autorenewalID !== undefined &&
        this.autorenewalID !== '') {
        address.autoRenewalId = this.autorenewalID;
      }
      this.$store.commit('startLoading');
      MswApiService.editQuote.updateBillingInfo(address)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.$emit('on-edit-billing-address', { result: 'success' });
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
            this.$store.commit('enqueueMessage', message);
            this.$emit('on-edit-billing-address', { result: 'failure' });
          }
        })
        .catch((errResponse: any) => {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'failed', infoMsg: errResponse.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.$emit('on-edit-billing-address', { result: 'failure' });
        });
    }
  }
  enableCCInfoEdit() {
    if (this.isCCDataEditable) {
      this.selectedCardType = 'none';
      this.addressInfo.creditCardNo = '';
      this.addressInfo.cvv = '';
      this.ccNoInputTouched = false;
      this.ccCVVInputTouched = false;
      this.validateCard();
    } else {
      this.selectedCardType = this.initCardType;
      this.addressInfo.creditCardNo = this.initCCNo;
      this.addressInfo.cvv = this.initSecurityCode;
      this.selectedMonth = this.months.filter(month => month.value === this.initCCMonth.value)[0];
      this.selectedYear = this.initCCYear;
      if (this.selectedCardType) this.setImgCardType(this.selectedCardType);
    }
  }
  validateCard(onBlur: boolean = false) {
    if (onBlur) {
      this.ccNoInputTouched = true;
    }
    this.isCardTypeErr = false;
    if (this.addressInfo.creditCardNo != null && this.addressInfo.creditCardNo.length) {
      this.selectedCardType = RegexValidators.getCreditCardType(this.addressInfo.creditCardNo);
      if (this.selectedCardType === 'none') {
        this.isCardTypeErr = true;
      } else {
        if (this.selectedCardType) this.setImgCardType(this.selectedCardType);
      }
    } else {
      this.selectedCardType = 'none';
      this.imgCardType = '';
    }
  }
  get getMonths() : SelectOption[] {
    return this.months;
  }
  get getYears() : SelectOption[] {
    return  this.years;
  }
  setImgCardType(cardtypes: any) {
    switch (cardtypes) {
      case 'VISA': this.imgCardType = this.visaPath;
        break;
      case 'MAST': this.imgCardType = this.mastercaerPath;
        break;
      case 'DISC': this.imgCardType = this.discoverPath;
        break;
      case 'AMEX': this.imgCardType = this.amexPath;
        break;
      default: this.imgCardType = '';
    }
  }
  getWidthConfig() {
    const widthConfig = {
      label: 50,
      field: 50,
    };
    return widthConfig;
  }

  get getInitialValue() {
    return this.addressInfo;
  }

  cvvInputBlurred() {
    this.ccCVVInputTouched = true;
  }
  onClickCancel() {
    this.$emit('on-edit-billing-address', { result: 'failure' });
  }
}
